import api from './lib/api';
import { isPageCloseBlocked } from './lib/pageCloseBlocking';

const UPDATE_CHECK_INTERVAL = 15 * 60 * 1000; // 15 minutes
// When the page is in the background, the update checks stop after this
// threshold is reached.
const UPDATE_CHECK_PAUSE_THRESHOLD = 60 * 60 * 1000; // 1 hour

type VersionResponse = {
  version: string;
};

const getApiVersion = async (): Promise<string> => {
  const { version: apiVersion } = await api.get<VersionResponse>('/version');

  return apiVersion;
};

const runBackgroundUpdateChecker = async (): Promise<void> => {
  const initialRegisteredApiVersion = await getApiVersion();

  let documentHiddenSince: number | null = null;

  document.addEventListener('visibilitychange', (): void => {
    documentHiddenSince = document.hidden ? Date.now() : null;
  });

  setInterval(async (): Promise<void> => {
    // Avoid perpetually making requests to spare the backend
    if (
      documentHiddenSince !== null &&
      Date.now() - documentHiddenSince > UPDATE_CHECK_PAUSE_THRESHOLD
    ) {
      return;
    }

    try {
      const apiVersion = await getApiVersion();

      if (apiVersion !== initialRegisteredApiVersion && !isPageCloseBlocked()) {
        window.location.reload();
      }
    } catch {
      // no-op: this runs in the background, the user may have temporarily
      // disconnected from the internet. Either way, we want this to fail
      // silently.
    }
  }, UPDATE_CHECK_INTERVAL);
};

export default runBackgroundUpdateChecker;
